import O from "@babel/runtime/helpers/esm/slicedToArray";
import w from "@babel/runtime/helpers/esm/toConsumableArray";
import c, { cloneElement as j } from "react";
import B from "@semcore/core";
import { useForkRef as F, getNodeByRef as m } from "@semcore/utils/lib/ref";
import H from "@semcore/utils/lib/ownerDocument";
import M from "@semcore/utils/lib/use/useEventCallback";
import I from "@semcore/utils/lib/getOriginChildren";
import { getEventTarget as T } from "@semcore/utils/lib/getEventTarget";
var q = function() {
};
function i(t) {
  var L = t.Children, _ = t.forwardRef, l = t.root, p = t.excludeRefs, E = p === void 0 ? [] : p, C = t.onOutsideClick, s = C === void 0 ? q : C, a = I(L), v = c.useRef(null), h = c.useRef(!1), y = F(a ? a.ref : null, v, _), d = M(function(e) {
    var u = [].concat(w(E), [v]).map(function(o) {
      return m(o);
    }), r = T(e), n = u.some(function(o) {
      return h.current || (o == null ? void 0 : o.contains(r));
    });
    n || s == null || s(e);
  }), f = M(function(e) {
    var u = [].concat(w(E), [v]).map(function(n) {
      return m(n);
    }), r = T(e);
    h.current = u.some(function(n) {
      return n == null ? void 0 : n.contains(r);
    });
  }), R = function(u, r) {
    var n = r instanceof HTMLElement && r.dataset.uiName === "Modal.Overlay";
    n && i.eventsMap.forEach(function(o) {
      var g = O(o, 2), x = g[0], N = g[1];
      Object.entries(N).forEach(function(b) {
        var k = O(b, 2), D = k[0], $ = k[1], A = u ? "addEventListener" : "removeEventListener";
        x[A](D, $, !0);
      });
    });
  };
  return c.useEffect(function() {
    var e = l ? m(l) : H(v.current);
    return R(!1, e), e == null || e.addEventListener("mouseup", d, !0), e == null || e.addEventListener("mousedown", f, !0), e && i.eventsMap.push([e, {
      mouseup: d,
      mousedown: f
    }]), function() {
      e && i.eventsMap.pop(), e == null || e.removeEventListener("mouseup", d, !0), e == null || e.removeEventListener("mousedown", f, !0), R(!0, e);
    };
  }, [l]), a ? /* @__PURE__ */ j(a, {
    ref: y
  }) : null;
}
i.displayName = "OutsideClick";
i.eventsMap = [];
const W = B(i);
export {
  W as default
};
